import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import IStore from '../../models/IStore';
import { ReduxDispatch } from '../../models/ReduxProps';
import * as ActionUtility from '../../utilities/ActionUtility';
import FileServiceEffect from '../effects/fileServiceEffect';
import { FileDownloadModel, FilePathModel as FileObjectModel } from '../models/FileServiceModel';

type ActionUnion = void | HttpErrorResponseModel | FileObjectModel[] | FileDownloadModel;

export default class FileServiceActions {
	public static readonly REQUEST_GET_FILES = 'FileServiceActions.REQUEST_GET_FILES';
	public static readonly REQUEST_GET_FILES_FINISHED = 'FileServiceActions.REQUEST_GET_FILES_FINISHED';
	public static readonly REQUEST_GET_FILE_DATA = 'FileServiceActions.REQUEST_GET_FILE_DATA';
	public static readonly REQUEST_GET_FILE_DATA_FINISHED = 'FileServiceActions.REQUEST_GET_FILE_DATA_FINISHED';
	public static readonly REQUEST_DOWNLOAD_FILES = 'FileServiceActions.REQUEST_DOWNLOAD_FILES';
	public static readonly REQUEST_DOWNLOAD_FILES_FINISHED = 'FileServiceActions.REQUEST_DOWNLOAD_FILES_FINISHED';

	public static getFiles = (navigationPath?: string): any => {
		return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
			return ActionUtility.createThunkEffect<FileObjectModel[]>(
				dispatch,
				getState(),
				FileServiceActions.REQUEST_GET_FILES,
				FileServiceEffect.getFiles,
				navigationPath
			);
		};
	};

	public static getFileData = (filePath: string): any => {
		return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
			return ActionUtility.createThunkEffect<FileDownloadModel>(
				dispatch,
				getState(),
				FileServiceActions.REQUEST_GET_FILE_DATA,
				FileServiceEffect.getFileData,
				filePath
			);
		};
	};

	public static downloadFiles = (prefix: string): any => {
		return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
			return ActionUtility.createThunkEffect<FileDownloadModel>(
				dispatch,
				getState(),
				FileServiceActions.REQUEST_DOWNLOAD_FILES,
				FileServiceEffect.downloadFiles,
				prefix
			);
		};
	};
}

